import { render, staticRenderFns } from "./RegisterLegalAgreement.vue?vue&type=template&id=d31fa098"
import script from "./RegisterLegalAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterLegalAgreement.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports